import { Toolbar, Card, TableContainer, Table, TableHead, TableRow, TableCell, Typography, Box, TableBody } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { Raffle } from '../../types/raffle';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import { CloneButton, EditButton, usePermissions } from 'react-admin';
import { useDispatch } from "react-redux";
import { setMark } from '../../redux/actions/propertyActions';
import { getDate } from '../../helpers/dateHelper';
import { checkPermission } from '../../helpers/checkPermissions';

interface ActiveDreamHomeProps {
    toggleDreamHome: (e) => void
    isActive: boolean
    changeStatus: (raffle: Raffle) => Promise<void | undefined>
    raffle: Array<Raffle> | null
}
interface ActiveDreamHomeState {
    activeRaffle: Array<Raffle> | null
}

const ActiveDreamHome: FC<ActiveDreamHomeProps> = ({ toggleDreamHome, isActive, changeStatus, raffle }) => {
    let { permissions } = usePermissions()
    const dispatch = useDispatch()
    const [state, setState] = useState<ActiveDreamHomeState>({
        activeRaffle: null
    })

    const markClone = () => {
        dispatch(setMark())
    }

    const removeActive = (raffle: Raffle) => {
        raffle.active = false
        raffle.isClosed = true
        changeStatus(raffle)
        setState({ ...state, activeRaffle: Array<Raffle>() })
    }

    return (
        <>
            <Toolbar id="active-toggle">
                <div className="active-table-title">
                    {isActive && <Typography variant="h6" gutterBottom className="base-color">
                        Active Dream Home
                    </Typography>}
                </div>
                <div className="mid">
                    <label className="rocker rocker-small">
                        <input type="checkbox" onClick={toggleDreamHome} checked={isActive} />
                        <span className="switch-left base-color">Active and new dream home</span>
                        <span className="switch-right">Inactive dream <br />home</span>
                    </label>
                </div>
            </Toolbar>

            {isActive && <Card className="active-table-card">
                <TableContainer>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow className="order-row">
                                <TableCell id="active-table-head" align="left">#</TableCell>
                                <TableCell id="active-table-head" align="left">Title</TableCell>
                                <TableCell id="active-table-head" align="left">Discount</TableCell>
                                <TableCell id="active-table-head" align="left">Start Date</TableCell>
                                <TableCell id="active-table-head" align="left">Date of completion</TableCell>
                                {
                                    checkPermission(permissions, "Dream home", "Update") &&
                                    <TableCell id="active-table-head-actions" align="left">Actions</TableCell>
                                }
                            </TableRow>
                        </TableHead>
                        {raffle ? raffle.map((item: Raffle) => {
                            return (
                                <TableBody key={item._id}>
                                    <TableRow className="order-row">
                                        <TableCell component="th">
                                            {item._id}
                                        </TableCell>
                                        <TableCell>
                                            {item.title}
                                        </TableCell>
                                        <TableCell>
                                            <Box display="flex" justifyContent="center">
                                                {item.isActiveDiscount ? <DoneOutlineIcon /> : '-'}
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            {getDate(new Date(item.startAt))}
                                        </TableCell>
                                        <TableCell>
                                            {getDate(new Date(item.endsAt))}
                                        </TableCell>
                                        {
                                            checkPermission(permissions, "Dream home", "Update") &&
                                            <TableCell >
                                                {raffle ? <div className="actions-table-body">
                                                    <CloneButton record={item} to={`dreamhome/${item.id}`} onClick={markClone} />
                                                    <EditButton to={`dreamhome/${item.id}`} className="edit-dreamhome" />
                                                    <label className="switch">
                                                        <input type="checkbox" checked={item.active} onClick={() => removeActive(item)} />
                                                        <span className="slider round"></span>
                                                    </label>
                                                </div> : <div></div>}
                                            </TableCell>
                                        }
                                    </TableRow>
                                </TableBody>
                            )
                        }) : null}
                    </Table>
                </TableContainer>
                {
                    raffle && raffle.length === 0 &&
                    <div className="no-active">
                        <Typography variant="h6" gutterBottom className="base-color">
                            There is no active prizes to display
                        </Typography>
                    </div>}
            </Card>}
        </>
    )
}

export default ActiveDreamHome